import { Injectable } from '@angular/core';
import { PartialWithRequired } from 'app/core/utils/partial-with-required';

export type GtmEventInfo = {
  /** {{page path}} */
  screen_name: string | null;

  /**
   * not an unique id
   */
  user_action: string | null;

  /** template identifier (e.g. contentType) */
  template: string | null;

  /** {{closest header}} */
  header: string | null;

  /** {{click text}} */
  click_text: string | null;

  /** {{question text}} */
  question_text: string | null;

  /** {{search term}} */
  search_term: string | null;

  /** {{article name}} or {{conference name}} or {{video name}} etc */
  content_name: string | null;

  /** {{click level 1}} */
  click_level_1: string | null;

  /** {{click level 2}} */
  click_level_2: string | null;

  /** {{click level 3}} */
  click_level_3: string | null;

  /** {{conference tags}} */
  tags: string | null;

  /** {{medical domain name}} */
  medical_domain: string | null;

  /** {{medical department}} */
  medical_department: string | null;

  /** {{institue name}} */
  institue_name: string | null;

  /** {{age}} */
  age: string | null;

  /** {{gender}} */
  gender: string | null;

  /** {{true | false}} */
  past_visit: string | boolean | null;

  /** {{status selection from drop down}} */
  status: string | boolean | null;

  /** {{disease name}} */
  disease_name: string | boolean | null;

  /** {{doctor name}} */
  doctor_name: string | null;

  /** {{main specialty}} */
  main_specialty: string | null;

  /** {{sub specialty}} */
  sub_specialty: string | null;

  /** {{filter by}} */
  filter_by: string | null;

  /** {{platform name}} */
  platform: string | null;

  /** {{clinic name}} */
  clinic: string | null;
};

/**
 * Event Name
 *
 * Template name
 */
export type GtmEvent =
  | 'homepage' // T1
  | 'menu_clicks' // All Templates
  | 'switch_language' // All Templates
  | 'internal_search' // All Templates
  | 'newsletter_success' // All Templates
  | 'footer' // All Templates
  | 'emails' // All Templates
  | 'institute' // T4
  | 'medical_domain' // T3
  | 'article' // T5, T6
  | 'doctors' // T9
  | 'courses_events' // T10
  | 'locations' // T13
  | 'choose_doctor' // T15
  | 'news_and_content' // T20
  | 'sheba_baby' // T21
  | 'page_not_found';//404

/**
 * Google Tag Manager event interface
 * - Whenever a parameter is not relevant or available send it as null
 */
export type GtmPushEvent = {
  event: GtmEvent;
  eventInfo: PartialWithRequired<GtmEventInfo, 'screen_name' | 'user_action' | 'template' | 'header'>;
};

declare global {
  interface Window {
    dataLayer?: GtmPushEvent[];
  }
}

@Injectable({ providedIn: 'root' })
export class ShebaGTMService {
  #window = window;

  get #dataLayer(): GtmPushEvent[] | undefined {
    return this.#window.dataLayer;
  }

  public push(item: GtmPushEvent): void {
    if (!window.dataLayer) {
      window.dataLayer = [];
    }
    this.#dataLayer?.push(item);
  }
}
